import React, { Component } from "react";
import {
  FormGroup,
  FormControl,
  FormLabel,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { Button } from "semantic-ui-react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//alert
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
//action
import {
  onBeforeHotChange,
  setEditTableHeight,
  toggleReadOnly,
} from "../../actions/editTableActions";
import { setFindAllSelectRowCol } from "../../actions/transOperation_find_Actions";
import { setCurrentUser, set_fId } from "../../actions/authActions";
import { signUser } from "../../actions/authActions";
//help
import ApiUtils from "../../helper/ApiUtils";

import Spinner from "../common/Spinner";
import { Form, Message, Input } from "semantic-ui-react";
import Popup from "reactjs-popup";
import DWSlogo from "../../images/DWSlogo.png";

const md5 = require("md5");

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fEmail: "",
      setEmail: "",
      password: "",
      setPassword: "",
      loading: false,
      fUserId: "",
      fPwd: "",
      fName: "",
      fPhone: "",
      isOpen: false,
      isStaySignedIn: false,
      loginError: false,
    };

    this.validateForm = this.validateForm.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  validateForm() {
    const { fEmail, password } = this.state;
    return fEmail.length > 0 && password.length > 0;
  }

  async handleSubmit(event) {
    event.preventDefault();

    // const fId = await ApiUtils.post_sql(`${ApiUtils.post_login}`,{
    //     "fEmail":this.state.email,
    //     "fPwd":this.state.password
    // });

    //alert(fId);
    // this.props.setCurrentUser(fId);
    // this.props.set_fId(fId);

    //this.props.history.push('/Home');
  }

  async componentWillReceiveProps(nextProps) {
    if (nextProps.editTable) {
    }
  }

  render() {
    const {
      isOpen,
      fEmail,
      password,
      loading,
      fUserId,
      loginError,
      fPwd,
      fName,
      fPhone,
    } = this.state;

    let mainView;
    if (loading === true) {
      mainView = (
        <div className="container pt-5">
          <Spinner />
        </div>
      );
    } else {
      mainView = (
        <div
          className="Login position-relative"
          style={{
            backgroundColor: "white",
            height: `${window.innerHeight}px`,
          }}
        >
          <Button
            size={"tiny"}
            className="position-absolute"
            style={{ top: "10px", right: "10px" }}
            secondary
            onClick={() => {
              this.setState({ isOpen: true });
            }}
          >
            Register
          </Button>

          <Container
            style={{
              width: "400px",
              paddingTop: "100px",
            }}
          >
            <Row>
              <div className={"col-12 text-center"}>
                <img src={DWSlogo} alt="Logo" width={90} />
              </div>
              <div className={"col-12 text-left"}>
                <Form
                  error={loginError}
                  style={{ width: "400px" }}
                  className={"mt-5"}
                  // onSubmit={this.handleSubmit}
                >
                  <Form.Field>
                    <label>Email</label>
                    <Input
                      icon="user"
                      iconPosition="left"
                      placeholder="Email"
                      autoFocus
                      type="text"
                      value={fEmail}
                      onChange={(e) => {
                        this.setState({ fEmail: e.target.value });
                      }}
                    />
                  </Form.Field>
                  <Form.Field className={"mt-3"}>
                    <label>Password</label>

                    <Input
                      icon="unlock"
                      iconPosition="left"
                      autoFocus
                      placeholder="Password"
                      value={password}
                      onChange={(e) => {
                        this.setState({ password: e.target.value });
                      }}
                      type="password"
                    />
                  </Form.Field>

                  <Message
                    error
                    header="Error"
                    content="Incorrect Email or Password"
                  />

                  <Form.Field className={" w-100"}>
                    {/*<FormField name="Stay Signed In"*/}
                    {/*           label='Target'*/}
                    {/*           labelPosition='after'*/}
                    {/*           labelAlign="left"*/}
                    {/*           style={{ marginBottom: 0 ,width: 70,float:'left'}}>*/}

                    {/*    <CheckBox checked={this.state.isStaySignedIn}/>*/}

                    {/*</FormField>*/}
                  </Form.Field>

                  <Button
                    className={"mt-5 w-100"}
                    primary
                    type="button"
                    disabled={!this.validateForm()}
                    onClick={async () => {
                      this.setState({ loading: true });

                      try {
                        const signUserResult = await this.props.signUser({
                          fEmail: this.state.fEmail,
                          fPwd: md5(this.state.password),
                        });
 

                        if (signUserResult === true) {
                          this.props.history.push("/Home");
                        } else {
                          //

                          this.setState({ loginError: true });
                        }
                      } catch (err) {
                        alert(JSON.stringify(err)); 
                      }
                      this.setState({ loading: false });
                    }}
                  >
                    Login
                  </Button>
                </Form>

                {/*<small> Freelancer_TR_1 / 123456</small><br/>*/}
                {/*<small> Freelancer_QC_1 / 123456</small>*/}
              </div>
            </Row>

            <Row>
              <Popup
                open={isOpen}
                modal
                closeOnDocumentClick
                onClose={() => {}}
                contentStyle={{ width: "600px", padding: "20px" }}
              >
                <Form>
                  <FormLabel>Email</FormLabel>
                  <FormControl
                    placeholder="Email"
                    autoFocus
                    type="text"
                    value={fEmail}
                    onChange={(e) => {
                      this.setState({ fEmail: e.target.value });
                    }}
                  />
                  <Form.Input
                    label="Enter Password"
                    type="password"
                    value={fPwd}
                    onChange={(e) => {
                      this.setState({ fPwd: e.target.value });
                    }}
                  />
                  <FormGroup controlId="fName" bssize="large">
                    <FormLabel>Name</FormLabel>
                    <FormControl
                      placeholder="Name"
                      autoFocus
                      type="text"
                      value={fName}
                      onChange={(e) => {
                        this.setState({ fName: e.target.value });
                      }}
                    />
                  </FormGroup>
                  <FormGroup controlId="fPhone" bssize="large">
                    <FormLabel>Phone</FormLabel>
                    <FormControl
                      placeholder="Phone"
                      autoFocus
                      type="text"
                      value={fPhone}
                      onChange={(e) => {
                        this.setState({ fPhone: e.target.value });
                      }}
                    />
                  </FormGroup>
                  <Button
                    type="button"
                    onClick={async () => {
                      //新增
                      const reault = await ApiUtils.post_sql(
                        `${ApiUtils.post_AddNewFreelancer}`,
                        {
                          fUserId: fEmail,
                          fPwd: md5(fPwd),
                          fPhone: fPhone,
                          fName: fName,
                          fEmail: fEmail,
                          fType: 0,
                          fLevel: 3,
                        }
                      );

                      if (parseFloat(reault) === 1) {
                        alert("New member success");
                        this.setState({ isOpen: false });
                      } else {
                        alert("Failed to add member");
                      }
                    }}
                  >
                    Submit
                  </Button>
                </Form>
              </Popup>
            </Row>
          </Container>
        </div>
      );
    }

    return mainView;
  }
}

Login.propTypes = {
  errors: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  transOperation: PropTypes.object.isRequired,
  findOperation: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
  errors: state.errors,
  transOperation: state.transOperation,
  editTable: state.editTable,
  findOperation: state.findOperation,
});

export default connect(mapStateToProps, {
  signUser,
  set_fId,
  onBeforeHotChange,
  toggleReadOnly,

  setFindAllSelectRowCol,
  setEditTableHeight,
  setCurrentUser,
})(withRouter(Login));



// WEBPACK FOOTER //
// ./src/components/auth/Login.js